"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (node) {
    if (!node) {
        return document.documentElement;
    }
    var excludeStaticParent = node.style.position === "absolute";
    var overflowRegex = /(scroll|auto)/;
    var parent = node;
    while (parent) {
        if (!parent.parentNode) {
            return node.ownerDocument.documentElement || document.documentElement;
        }
        var style = window.getComputedStyle(parent);
        var position = style.position;
        var overflow = style.overflow;
        var overflowX = style.overflowX;
        var overflowY = style.overflowY;
        if (position === "static" && excludeStaticParent) {
            continue;
        }
        if (overflowRegex.test([overflow, overflowX, overflowY].join(""))) {
            return parent;
        }
        parent = parent.parentNode;
    }
    return node.ownerDocument.documentElement || document.documentElement;
});
